import React, { ReactNode } from "react"
import Dialog from "@mui/material/Dialog"
import Fade from "@mui/material/Fade"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"

interface CustomDialogProps {
  open: boolean
  scroll?: "body" | "paper"
  children: ReactNode
  [x: string]: any
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  scroll,
  children,
  ...props
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  // prefer paper scrolling on mobile
  const dialogScroll: "body" | "paper" = scroll ?? (isMobile ? "paper" : "body")

  return (
    <Dialog
      open={open}
      fullScreen={isMobile}
      maxWidth="xl"
      scroll={dialogScroll}
      PaperProps={{
        sx: {
          width: isMobile ? "100%" : "75%",
          height: isMobile ? "100dvh" : "auto",
          maxHeight: isMobile ? "100dvh" : "calc(100% - 64px)",
          backgroundColor: "transparent",
          borderRadius: isMobile ? 0 : 0,
          boxShadow: "none",
          overflowY: dialogScroll === "paper" ? "auto" : "hidden",
          overscrollBehavior: "contain",
          WebkitOverflowScrolling: "touch",
        },
      }}
      sx={{
        // Fix for mobile Chrome: reset transforms to ensure full viewport height
        position: isMobile ? "fixed" : "absolute",
        "& .MuiDialog-root": {
          transform: "none !important",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: {
            xs: "#ffffff",
            sm: "rgba(0, 0, 0, 0.87)",
          },
          position: isMobile ? "fixed" : "absolute",
          transform: "none !important",
        },
        "& .MuiDialogContent-root": {
          padding: 0,
          overscrollBehavior: "contain",
          WebkitOverflowScrolling: "touch",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      }}
      TransitionComponent={Fade}
      {...props}
    >
      {children}
    </Dialog>
  )
}

export default CustomDialog
